import {FC, useState} from 'react'
import {Button, ErrorMessage} from '_core'

type Props = {
  onSubmit: (discountCode: any) => any
}

const DiscountCode: FC<Props> = ({onSubmit}) => {
  const [discountCode, setDiscountCode] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handelDiscountCodeChange = (e: any) => {
    const {value} = e.target
    setDiscountCode(value)
    setErrorMessage('')
  }

  const handelDiscountCode = async () => {
    try {
      if (discountCode.length === 0) {
        setErrorMessage('Please Enter an discount code')
        return
      }
      setIsSubmitting(true)
      const discount = await onSubmit(discountCode)
      if (discount && discount.status !== 'success') {
        setErrorMessage('Discount code is not valid')
        setTimeout(() => {
          setErrorMessage('')
        }, 4000)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className='row'>
      <div className='col-6'>
        <input
          type='text'
          className='form-control w-100'
          placeholder='Discount code'
          value={discountCode}
          onChange={handelDiscountCodeChange}
        />
      </div>
      <div className='col'>
        <Button
          id='btnCustomerTagSave'
          type='submit'
          title='Apply'
          isSubmitting={isSubmitting}
          className='btn-primary btn-sm'
          onClick={handelDiscountCode}
        />
      </div>
      <ErrorMessage error={errorMessage} />
    </div>
  )
}
export default DiscountCode
